module.exports = __webpack_public_path__ + "static/media/icon-twitter.44009918.svg";